import _ from 'lodash'
import {getContrastFontColorByBackground} from '../../helpers/styles'

export function coloredAvailableServices(state) {
  let result = [];
  const availableServiceGroupsById = _.keyBy(state.availableServiceGroups, 'id');
  for (let service of state.availableServices) {
    const backgroundColor = _.get(availableServiceGroupsById, [service.groupId, 'colorScheme'], void 0);

    result.push({
      id: service.id,
      code: service.code,
      title: `(${service.code}) ${service.title}`,
      backgroundColor: backgroundColor,
      fontColor: getContrastFontColorByBackground(backgroundColor)
    })
  }

  return _.orderBy(result, 'code', 'asc')
}

/**
 * return list of service ids
 */
export function getClientServices(state) {
  return clientId => {
    if (_.keys(state.servicesByClients).length === 0) {
      return [] // not loaded yet
    }

    let clientServicesByClientId = {};
    _.forOwn(state.servicesByClients, service => {
      _.forOwn(service, clientService => {
        let clientId = clientService.clientId;
        if (!clientServicesByClientId[clientId]) {
          clientServicesByClientId[clientId] = []
        }
        clientServicesByClientId[clientId].push(clientService)
      })
    });

    let result = clientServicesByClientId[clientId].map(it => it.serviceId);
    return result
  }
}

/**
 * return list of service ids
 */
export function getClientServicesNotHidden(state) {
  return clientId => {
    if (_.keys(state.servicesByClients).length === 0) {
      return [] // not loaded yet
    }

    let clientServicesByClientId = {};
    _.forOwn(state.servicesByClients, service => {
      _.forOwn(service, clientService => {
        let clientId = clientService.clientId;
        if (!clientServicesByClientId[clientId]) {
          clientServicesByClientId[clientId] = []
        }
        clientServicesByClientId[clientId].push(clientService)
      })
    });

    let result = clientServicesByClientId[clientId]
      .filter(it => !it.hidden)
      .map(it => it.serviceId);
    return result
  }
}



// WEBPACK FOOTER //
// ./src/store/getters/services.js